export default __webpack_public_path__ + "static/media/india2015A.8298966e.jpg";